<style lang='scss' scoped>
.locale-lang {
    cursor: pointer;
	padding: 0 !important;
    &-title {
        height: 100%;
        display: inline-flex;
        align-items: center;
		padding: 0 6px;
    }
    &:hover {
        .locale-lang-title {
            color: #4093ff;
            background-color: #09659A;
        }
        .nav-items {
            display: block;
        }
    }
}

.nav-items {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    line-height: 36px;
    min-width: 100%;
    white-space: nowrap;
    background-color: #09659A;
    box-shadow: 0 0 2px #ccc;
    & > li {
        padding: 0 20px;
        &:hover {
            color: #4093ff;
            background-color: #09659A;
        }
    }
}
</style>


<template>
	<aside class="locale-lang">
		<div class="locale-lang-title">
			<img :src="getLangData.icon" />&nbsp;{{getLangData.label}}
			<vIcon class="nav-hover" type="arrow-dropdown"></vIcon>
		</div>
		<ul class="nav-items">
			<li v-for="item in langList" @click="updateLang(item.value)">
				<img :src="item.icon" />&nbsp;{{item.label}}
			</li>
			<template v-if="isDebugLang">
				<li @click="handleDebug(1)">{{debugLang==1?'关闭':''}}多语言调试1</li>
				<li @click="handleDebug(2)">{{debugLang==2?'关闭':''}}多语言调试2</li>
			</template>
			<li @click="updateLangData(null,true)">{{$t('global.common.update_multilingual', { defaultValue: '更新当前语言包' })}}</li>
		</ul>
	</aside>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
	data() {
		return {
			langList: this.$store.state.langList,
			isDebugLang: process.env.VUE_APP_DEBUG_LANG == 1,
			debugLang: sessionStorage.getItem('DEBUG_LANG')
		};
	},
	methods: {
		...mapMutations(['setLang']),
		async updateLang(val) {
            if (this.lang === val) return;
            // console.log(val,'valvalval')
            this.bus.$emit("changelang", val);
			await this.updateLangData(val);
			await this.setLang(val);
            // await this.$store.dispatch('actionInitBaseData', { updateInit: true });

		},
		async handleDebug(debugType) {
			sessionStorage.setItem('DEBUG_LANG', this.debugLang == debugType ? '' : debugType);
			await this.updateLangData();
			location.reload();
		},
		async updateLangData(lang, isForce) {
			return this.$store.dispatch('actionGetLangList', { lang, isForce }).then(cb => cb(this.$i18n));
		},
	},
	computed: {
		...mapState(['lang']),
		getLangData() {
			return this.langList.find(item => item.value === this.lang) || this.langList[this.langList.length - 1];
		},

	},
};
</script>
